




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ProjectDto } from '@/models/dtos/projectDto'
import { UserDto } from '@/models/dtos/userDto'
import { SelectDto } from '@/models/dtos/selectDto'

@Component
export default class Filters extends Vue {
  @Prop({ type: Array, required: true }) projects!: ProjectDto[]

  private searchPhrase = ''
  private showInactive = false

  // Getters
  get filter() {
    return `${this.searchPhrase} ${this.showInactive}`
  }

  // Lifecycle
  created() {
    this.$emit('filter', this.searchPhrase, this.showInactive)
  }

  // Watchers
  @Watch('filter')
  onFilterChange(value: UserDto, oldValue: UserDto) {
    this.$emit('filter', this.searchPhrase, this.showInactive)
  }
}
